import React, { useEffect, useRef, useState } from "react";
import { uniqueId } from "lodash";
import Papa from "papaparse";

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import { useDebounce } from "../../../../../helpers/useDebounce";
import {
	decodeData,
	getColumnFilter,
	getSearchPattern,
	getUserTimezone,
	hasItems,
} from "../../../../../helpers/Utils";

//import FilterIconWidget from "../../../../../components/FilterIconWidget/FilterIconWidget";
import SectionTitleWidget from "../../../../../components/SectionTitleWidget/SectionTitleWidget";
import TableCell from "../../../../../components/tables/table-cell/TableCell";
import TableSearch from "../../../../../components/tables/table-search/TableSearch";

import ts from "../../../../../components/tables/Table.module.scss";
import s from "./ListingDetailsPreview.module.scss";

export default function ListingLineage({ product = {} }) {
	const [tableData, setTableData] = useState([]);
	const [allTableData, setAllTableData] = useState([]);
	const [columns, setColumns] = useState([]);
	const [showFilters] = useState(false);

	const [searchText, setSearchText] = useState("");
	const debouncedSearchTerm = useDebounce(searchText, 1000);

	const pageSize = 10;
	const tableRef = useRef({});

	useEffect(() => {
		search(searchText);
		// eslint-disable-next-line
	}, [debouncedSearchTerm]);

	useEffect(() => {
		if (product?.marketPreviewFile) {
			const fileContent = product.marketPreviewFile?.plain_content // content from config file
				? product.marketPreviewFile?.plain_content
				: decodeData(product.marketPreviewFile?.content) || [];

			try {
				const csv = Papa.parse(fileContent, { header: true });
				const data = csv?.data;
				const cols = Object.keys(data[0]);
				setColumns(cols);

				// Display data
				setTableData(data);

				// All data for filtering
				setAllTableData([...data]);
			} catch (error) {
				console.error("Error parsing csv file", error);
			}
		}
	}, [product?.marketPreviewFile]);

	// ------------------------------------- METHODS -------------------------------------
	const search = (term) => {
		let filteredData = allTableData;

		// Multi terms search
		if (term) {
			const pattern = getSearchPattern(term);
			filteredData = filteredData.filter((a) => {
				return (
					a.records?.match(pattern) ||
					a.timestamp?.match(pattern) ||
					a.operation?.match(pattern)
				);
			});
		}

		setTableData([...filteredData]);
	};

	/* const toggleFilters = () => {
		if (showFilters) {
			setShowFilters(false);

			// Clear filtered results
			columns.forEach(({ columnName }) => {
				tableRef.current[columnName].cleanFiltered();
			});
		} else {
			setShowFilters(true);
		}
	}; */

	// ------------------------------------- FORMATS -------------------------------------
	const columnFormatter = (cell) => {
		return <TableCell type="data" text={cell} />;
	};

	const dateFormatter = (cell) => {
		return (
			<TableCell
				popoverId={"tooltip_date_" + uniqueId()}
				type="date"
				text={cell}
			/>
		);
	};

	return (
		<div className={s.section}>
			<SectionTitleWidget title="Preview" className={s.sectionTitle} />

			<div className={ts.root}>
				{/* <FilterIconWidget onClick={toggleFilters} showFilters={showFilters} /> */}

				{hasItems(columns) && (
					<BootstrapTable
						data={tableData}
						options={{
							//defaultSortName: "id",
							//defaultSortOrder: "asc",
							sizePerPage: pageSize,
							hideSizePerPage: true,
							prePage: "< Previous", // Previous page button text
							nextPage: "Next >", // Next page button text
							withoutNoDataText: true,
							searchPanel: () => (
								<TableSearch
									searchText={searchText}
									setSearchText={setSearchText}
								/>
							),
						}}
						pagination={tableData && tableData.length > pageSize}
						className={ts.weavetable}
						version="4"
						search
					>
						{columns.map((columnName, index) => {
							const isIDColumn = columnName.toLowerCase() === "id";
							return (
								<TableHeaderColumn
									key={index}
									isKey={isIDColumn || index === 0}
									dataField={columnName}
									width={isIDColumn ? "150" : "200"}
									dataSort
									ref={(el) => (tableRef.current[columnName] = el)}
									filter={showFilters ? getColumnFilter("string") : null}
									dataFormat={
										columnName === "timestamp" ? dateFormatter : columnFormatter
									}
								>
									{columnName === "timestamp"
										? `Timestamp ${getUserTimezone()}`
										: columnName}
								</TableHeaderColumn>
							);
						})}
					</BootstrapTable>
				)}
			</div>
		</div>
	);
}
